import type { TError, TLessonProgressBase, TUpdateProgress } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { invalidateMyAnalytics } from '../my-analytics/get-my-analytics';
import { getProgressQueryKey } from './get-progress';
import { getVideoPlayedBlocksQueryKey } from './get-video-played-blocks';

/**
 * Hook to update user's progress on a lesson
 * Automatically invalidates progress query on success
 *
 * @param lessonId - Lesson ID (UUID)
 */
export const useUpdateProgress = (lessonId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TLessonProgressBase, TError, TUpdateProgress>({
    mutationFn: async data => {
      const res = await axios.patch<TLessonProgressBase>(`/community-hub/lessons/${lessonId}/progress`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getProgressQueryKey(lessonId) });
      // A play ping creates a VIDEO_PLAY record — refresh the played map so
      // the playlist's CONTINUE WATCHING pill reflects it without a reload.
      queryClient.invalidateQueries({ queryKey: getVideoPlayedBlocksQueryKey(lessonId) });
      invalidateMyAnalytics(queryClient);
    },
  });
};
